import { AirplanemodeInactiveRounded } from '@material-ui/icons';
import { Progress } from 'antd';
import React, { useState } from 'react'
import { antiNameHandler } from '../../modules/anti_name_handler';
import getStringsBasedLang from '../../strings/get_strings';

export default function Anitiviruses(props) {
    const lang = localStorage.getItem('lang')
    let avs = []
    Object.values(props.data.malware.compressed).map((data, index) => { // compressed files
        Object.values(data).forEach((element) => {
            element.forEach((res) => {
                avs.push({ "av_name": res.av_name, 'malware_name': res.malware_name })
            })
        });
    })

    Object.values(props.data.malware.normal).map((data, index) => { // normal files
        data.forEach((res) => {
            avs.push({ "av_name": res.av_name, 'malware_name': res.malware_name })
        })
    })

    const iconHandler = (av_name) => {
        if ((props.data.finished_at && props.data.progress[av_name] !== 100))
            return <span className='text-red-500 font-bold'>{getStringsBasedLang("error")}</span>

        const progress = Object.keys(props.data.progress)
        for (const av_progress of progress) {
            if (av_progress === av_name) {
                if (props.data.progress[av_name] === 100) {

                    let txt = ''
                    for (const data of avs) {
                        if (data.av_name === av_name) {
                            txt = data.malware_name
                        }
                    }
                    return (
                        txt ?
                            <span className={`${txt ? 'text-red-500' : 'text-green-500'} font-bold‍‍‍ englishIranSans`}>{txt}</span>
                            :
                            <img src={require('../../assets/icons/checked.png')} alt="check" />
                    )
                }
                else {
                    return <div className=''><Progress type='circle' percent={props.data.progress[av_name]} size='small' /></div>
                }
            }

        }
        return <div className='primary_text_color text-sm'>{getStringsBasedLang("scan_title")}...</div>

    }
    const mapHandler = (av_name, index) => {
        return (
            <div key={index} className={`flex justify-between items-center px-2 bg-gray-100 rounded-lg py-2 xs:col-span-2 sm:col-span-2 ${props.data.avs.length > 1 ? 'col-span-1' : 'col-span-2'}`}>
                <div className='flex justify-center items-center'>
                    <img className={`w-6 h-6 ${lang === 'en' ? 'mr-1' : 'ml-1'}`} src={require(`../../assets/icons/${antiNameHandler(av_name) === 'Unknown' ? 'question' : av_name}.png`)} alt="Icon" />
                    <span className='primary_text_color text-sm englishIranSans'>{antiNameHandler(av_name)}</span>
                </div>
                <div className='truncate text-left'>{iconHandler(av_name)}</div>
            </div>
        )
    }
    return (
        <div>
            <div><span className='primary_text_color font-bold text-lg'>{getStringsBasedLang("avScanResult")}</span></div>
            <div className={`grid grid-cols-2 gap-3 mt-5`}>
                {
                    props.data.avs.map(mapHandler)
                }
            </div>
        </div>
    )
}
